import React from 'react';
import { motion } from 'framer-motion';
import { styles } from '../styles';
import { services } from '../constants';
import { fadeIn, textVariant } from '../utils/motion';
import { SectionWrapper } from '../hoc';

const ServiceCard = ({ index, title, icon }) => {
  return (
    <motion.div
      variants={fadeIn('right', 'spring', 0.5 * index, 0.75)}
      className='xs:w-[250px] w-full card-gradient p-[1px] rounded-[20px] shadow-card'>
      <div
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className='bg-jetLight rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col'>
        <img src={icon} alt={title} className='w-16 h-16 object-contain' />
        <h3 className='text-taupe text-[18px] font-bold text-center'>
          {title}
        </h3>
      </div>
    </motion.div>
  );
};

const About = () => {
  return (
    <div className='-mt-[6rem]'>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Introduction</p>
        <h2 className={styles.sectionHeadText}>Overview.</h2>
      </motion.div>

      <motion.p
        variants={fadeIn('', '', 0.1, 1)}
        className='mt-4 text-taupe text-[18px] max-w-3xl leading-[30px]'>
        Software Engineer with 10+ years of building and delivering scalable web
        applications, data-driven platforms and user-friendly, user focused
        software across a variety of domains. I have experience across the stack
        in a variety of technologies and frameworks.
        <br />
        Throughout my career, I’ve led and contributed to projects spanning
        analytics dashboards, email campaign and scheduling systems,
        administrative platforms, APIs, and data-driven applications. I enjoy
        solving complex engineering problems, improving application performance
        and reliability, and building intuitive experiences that turn complex
        data and workflows into practical tools for users.
        <br />
      </motion.p>

      <div className='mt-20 flex flex-wrap gap-10'>
        {services.map((service, index) => (
          <ServiceCard key={service.title} index={index} {...service} />
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(About, 'about');
